module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"create_addon":"Create Add-on","no_addons_yet":"No add-ons yet"},"id":{"create_addon":"Create Add-on","no_addons_yet":"Tiada add-ons"}}')
  delete Component.options._Ctor
}
